import { Injectable } from '@angular/core';
import { generateClient } from '@aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateProductLabelItemInput,
    DeleteProductLabelItemInput,
    ProductLabelItem,
    UpdateProductLabelItemInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class ProductLabelItemService {
    private amplifyClient = generateClient();

    async ProductLabelItem(): Promise<ProductLabelItem[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listProductLabelItems
                })
            ).data.listProductLabelItems.items;
            if (data) return data as ProductLabelItem[];
        } catch (error) {
            console.error('Error finding ProductLabelItem:', error);
            return null;
        }
    }

    async productLabelItemsByProductId(
        productId: string
    ): Promise<ProductLabelItem[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ProductLabelItemsByProductId,
                    variables: {
                        productId
                    }
                })
            ).data.ProductLabelItemsByProductId.items;
            if (data) return data as ProductLabelItem[];
        } catch (error) {
            console.error('Error finding ProductLabelItem:', error);
            return null;
        }
    }

    async productLabelItemsByProductLabelId(
        productLabelId: string
    ): Promise<ProductLabelItem[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ProductLabelItemsByProductLabelId,
                    variables: {
                        productLabelId
                    }
                })
            ).data.ProductLabelItemsByProductLabelId.items;
            if (data) return data as ProductLabelItem[];
        } catch (error) {
            console.error('Error finding ProductLabelItem:', error);
            return null;
        }
    }

    async createProductOption(
        input: CreateProductLabelItemInput
    ): Promise<ProductLabelItem> {
        try {
            const productOption = (
                await this.amplifyClient.graphql({
                    query: mutations.createProductLabelItem,
                    variables: {
                        input
                    }
                })
            ).data.createProductLabelItem;
            if (productOption) return productOption as ProductLabelItem;
        } catch (error) {
            console.error('Error creating ProductLabelItem:', error);
            return null;
        }
    }

    async updateProductOption(
        input: UpdateProductLabelItemInput
    ): Promise<ProductLabelItem> {
        try {
            const productOption = (
                await this.amplifyClient.graphql({
                    query: mutations.updateProductLabelItem,
                    variables: {
                        input
                    }
                })
            ).data.updateProductLabelItem;
            if (productOption) return productOption as ProductLabelItem;
        } catch (error) {
            console.error('Error updating productOptions:', error);
            return null;
        }
    }

    async deleteProductLabelItem(
        input: DeleteProductLabelItemInput
    ): Promise<ProductLabelItem> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteProductLabelItem,
                    variables: {
                        input
                    }
                })
            ).data.deleteProductLabelItem;
            if (date) return date as ProductLabelItem;
        } catch (error) {
            console.error('Error creating ProductLabelItem:', error);
            return null;
        }
    }
}
